"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAggStats = void 0;
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var sum_1 = __importDefault(require("lodash/sum"));
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var react_1 = require("react");
var useAggStats = function (recommendationAggregates, profile, isOwner, recommendations) { return (0, react_1.useMemo)(function () {
    if (!recommendationAggregates) {
        return null;
    }
    if (!profile || isOwner || !recommendations) {
        return __assign(__assign({}, recommendationAggregates), { totalCount: recommendationAggregates.allCount, totalSum: (0, sum_1.default)(Object.values(recommendationAggregates.sumByRecType)) });
    }
    var allRecs = Object.values(recommendations).flat().filter(function (r) { return !r.isSoftDelete; });
    return {
        countByRecType: (0, mapValues_1.default)(recommendations, function (r) { return r.length; }),
        sumByRecType: (0, mapValues_1.default)(recommendations, function (rs) { return (0, sumBy_1.default)(rs, function (r) { return r.potentialSavings || 0; }); }),
        totalSum: (0, sumBy_1.default)(allRecs, function (r) { return r.potentialSavings || 0; }),
        totalCount: allRecs.length,
    };
}, [isOwner, recommendations, recommendationAggregates]); };
exports.useAggStats = useAggStats;
